export const iconFontAwesomeTransportationPlaneSlash = (
	<i className="fa-solid fa-plane-slash"></i>
);
